import React from 'react';
import { FormattedMessage } from 'react-intl';
import Question from './question';

const CustomQuiz = ({ data, optionChange, onFinish, btnState }) => {
  return (
    <div className="quiz-items-wrapper">
      <div className="quiz-col">
        {data.slice(0, 3).map((item, idx) => (
          <Question
            key={idx}
            question={item}
            questionNo={idx + 1}
            handleChange={optionChange}
          />
        ))}
      </div>

      <div className="quiz-col">
        {data.slice(3, 5).map((item, idx) => (
          <Question
            key={idx}
            question={item}
            questionNo={idx + 4}
            handleChange={optionChange}
          />
        ))}
        <div className="quiz-item quiz-item__next">
          <button
            className="btn btn-color"
            disabled={btnState}
            onClick={onFinish}
          >
            <FormattedMessage id="dba.next" defaultMessage="Next" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomQuiz;
